import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export default {
  getQualifications(id) {
    return http.get(`qualifications/${id}`);
  },
};

export const getQualificationByAlias = (alias) =>
  http
    .get('qualifications', { params: { qualify_alias: alias } })
    .then(handleResponse);

/**
 * Get qualification on demand
 * @param {Object} params
 * @param {string} params.qualify_group_id - obrigatorio, para buscar nos
 * @param {string} params.qualify_father_id - opcional para buscar filhos
 * @param {string} params.alias - opcional, para busca
 * @returns {Promise}
 */
export const getQualificationOnDemand = (body) =>
  http.post('qualifications/on-demand', body).then(handleResponse);
